// =====================================================
// COMPONENT: TimelineFilters
// Description: Système de filtres pills selon Figma
// =====================================================

import { cn } from '@/lib/utils';

export type FilterType = 'all' | 'calls' | 'emails' | 'sequences' | 'tasks' | 'data' | 'payments';

interface TimelineFiltersProps {
  activeFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
}

export function TimelineFilters({ activeFilter, onFilterChange }: TimelineFiltersProps) {
  const filters: Array<{ key: FilterType; label: string }> = [
    { key: 'all', label: 'Tous' },
    { key: 'calls', label: 'Appels' },
    { key: 'emails', label: 'E-mails' },
    { key: 'sequences', label: 'Séquences' },
    { key: 'tasks', label: 'Tâches' },
    { key: 'data', label: 'Données' },
    { key: 'payments', label: 'Paiements' },
  ];

  return (
    <div className="bg-zinc-100 h-9 rounded-xl p-1 inline-flex gap-0.5">
      {filters.map((f) => (
        <button
          key={f.key}
          onClick={() => onFilterChange(f.key)}
          className={cn(
            'px-3 py-1 text-sm font-medium rounded-lg transition-all',
            activeFilter === f.key
              ? 'bg-white text-zinc-900 shadow-sm'
              : 'text-zinc-700 hover:text-zinc-900'
          )}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
